import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doctor-card-profile',
  templateUrl: './doctor-card-profile.component.html',
  styleUrls: ['./doctor-card-profile.component.scss'],
})
export class DoctorCardProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
